import React, { Fragment } from 'react';
import styles from './styles.module.css';

import PillButton from '../../../pill-button';
import CrossIcon from '../../../../icons/Cross';

const ERROR_MESSAGES = {
  OFFLINE: (
    <p>
      It looks like you are currently offline. Please reconnect and try again.
    </p>
  ),
  GENERIC_ERROR: (
    <p>There may be an issue with our system. Please try again later.</p>
  ),
  REQUEST_TOO_LARGE: (
    <Fragment>
      <p>The size of your uploads is too large for us to process.</p>
      <p>
        Unfortunately for technical reasons we can only accept submissions of up
        to 6MB in size. If you have any images that are larger than 6MB
        individually please reduce their file size before submitting them. If
        you have multiple images please try sending several submissions so that
        each submission is&nbsp;less&nbsp;than&nbsp;6MB.
      </p>
    </Fragment>
  ),
};

export default ({
  errorCode = 'GENERIC_ERROR',
  backToForm,
  retrySubmission,
}) => (
  <div className={styles.container}>
    <CrossIcon size={96} color="#AD343E" />
    <p>Failed to send submission</p>
    {navigator.onLine ? ERROR_MESSAGES[errorCode] : ERROR_MESSAGES.OFFLINE}
    <div className={styles.buttons}>
      <PillButton theme="grey-ghost" text="Back" onClick={backToForm} />
      {(!navigator.onLine || errorCode !== 'REQUEST_TOO_LARGE') && (
          <PillButton theme="blue" text="Retry" onClick={retrySubmission} />
        )}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/state-pages/submission-failed/index.js